import React from 'react'
import { Link } from 'react-router-dom'
import EventProBrand from './EventProBrand'
import { cardStyle, accent, bgMuted } from './styles'

export default function HowToPlayPage() {
  return <main style={{ minHeight: '100vh', background: bgMuted, padding: '24px 16px' }}>
    <article style={{ ...cardStyle, maxWidth: 560, margin: '0 auto', padding: 28, lineHeight: 1.7 }}>
      <EventProBrand />
      <h1>How to play</h1>
      <p>Build a timeline of famous pop-culture events. Everyone gets the same daily puzzle: one anchor year and four events to place.</p>
      <ol style={{ paddingLeft: 22 }}>
        <li><strong>Review the anchor.</strong> The playboard shows the anchor and a brief explanation with no timer running. Select Continue to reveal the first event and start the stopwatch.</li>
        <li><strong>Choose a position.</strong> Tap a dashed button before, after, or between events to place immediately. Each tap locks in your choice. Most recent events are at the top.</li>
        <li><strong>Keep building.</strong> Each choice locks in. The event joins its correct spot on the timeline, and a green or red mark shows whether you placed it correctly.</li>
        <li><strong>Finish all four.</strong> The timer stops immediately on your fourth placement. Then all years and your saved result are revealed.</li>
      </ol>
      <h2 style={{ fontSize: '1.2rem' }}>How the leaderboard works</h2>
      <p><strong>Correct placements come first.</strong> A 4/4 always beats a 3/4. Players with the same number correct are ranked by fastest elapsed time.</p>
      <p>Time is shown to hundredths of a second. Equal accuracy and time share a rank—for example, T1, T1, 3.</p>
      <h2 style={{ fontSize: '1.2rem' }}>One daily attempt</h2>
      <p>Your round is saved after every placement. Refreshing or leaving resumes the same attempt, and the clock keeps running. A new round becomes available each day at midnight in Arizona.</p>
      <p>Take the time you need to be accurate. There is no countdown or time limit.</p>
      <div style={{ display: 'flex', gap: 20 }}><Link to="/" style={{ color: accent }}>Back to game</Link><Link to="/leaderboard" style={{ color: accent }}>Leaderboard</Link></div>
    </article>
  </main>
}
